import { $fetch } from '@/boot/fetch'

const ENDPOINT = '/businesses'

export default {
  create(data) {
    return $fetch.peg(ENDPOINT, {
      method: 'POST',
      body: data,
    })
  },
  update(businessId, data) {
    return $fetch.peg(`${ENDPOINT}/${businessId}`, {
      method: 'PUT',
      body: data,
    })
  },
  getById(businessId) {
    return $fetch.peg(`${ENDPOINT}/${businessId}`)
  },
  addAddress(businessId, data) {
    return $fetch.peg(`${ENDPOINT}/${businessId}/addresses`, {
      method: 'POST',
      body: { countryCode: 'US', ...data },
    })
  },
  updateAddress(businessId, addressId, data) {
    return $fetch.peg(`${ENDPOINT}/${businessId}/addresses/${addressId}`, {
      method: 'PUT',
      body: { countryCode: 'US', ...data },
    })
  },
  uploadResaleCertificate(businessId, file) {
    const formData = new FormData()
    formData.append('resaleCertificate', file)

    return $fetch.peg(`${ENDPOINT}/${businessId}/resaleCertificates`, {
      method: 'POST',
      body: formData,
    })
  },
}
